/**
 * Phase 3 VAL-04 / D-12 — gst_rate is constrained to {0, 5, 12, 18, 28}.
 * HSN/SAC prefix → expected GST rate is ADVISORY only. Mismatches surface as
 * frontend warning toasts, not server-side rejections.
 */
export const ALLOWED_GST_RATES = [0, 5, 12, 18, 28] as const;

export const HSN_GST_ADVISORY: ReadonlyArray<{ prefix: string; rate: number }> = [
  { prefix: "4801", rate: 12 }, // Paper / newsprint
  { prefix: "4802", rate: 12 }, // Writing paper
  { prefix: "4820", rate: 12 }, // Notebooks, registers
  { prefix: "8443", rate: 18 }, // Printers / copiers
  { prefix: "2106", rate: 18 }, // Food preparations (snacks)
  { prefix: "2202", rate: 12 }, // Non-alcoholic beverages
  { prefix: "0901", rate: 5  }, // Coffee
  { prefix: "0902", rate: 5  }, // Tea
];

/** Returns true if the HSN prefix matches the GST rate, OR if the prefix is unknown. */
export function checkHsnGstMatch(hsnSacCode: string, gstRate: number): boolean {
  const entry = HSN_GST_ADVISORY.find((e) => hsnSacCode.startsWith(e.prefix));
  if (!entry) return true;
  return entry.rate === gstRate;
}
